'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Constants


var _intercomService = require('./intercomService');

var _getClientConfig = require('../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _rollbarService = require('./rollbarService');

var _analyticsEventMiddleware = require('./analyticsEventMiddleware');

var _analyticsEventMiddleware2 = _interopRequireDefault(_analyticsEventMiddleware);

var _analyticsActions = require('./analyticsActions');

var _analyticsConstants = require('./analyticsConstants');

var _currentUserConstants = require('../user/currentUserConstants');

var _authConstants = require('../auth/authConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var config = (0, _getClientConfig2.default)();

    // if no analytics enabled, return empty middleware
    if (!config.analytics || !config.analytics.enabled) {
        return function (store) {
            return function (next) {
                return function (action) {
                    return next(action);
                };
            };
        };
    }

    // send user data to intercom
    var sendUserData = function sendUserData(user) {
        var createdDate = parseInt(user._id.slice(0, 8), 16);

        var intercomUser = {
            user_id: user._id,
            created_at: createdDate,
            email: user.email,
            name: user.name && user.name.displayName,
            res_width: screen.availWidth,
            res_height: screen.availHeight,
            hide_default_launcher: true
        };

        (0, _intercomService.intercomBoot)(_extends({
            app_id: config.analytics.appId
        }, intercomUser));
    };

    var shutdownIntercom = function shutdownIntercom() {
        (0, _intercomService.intercomShutdown)();
    };

    // return analytics middleware
    return function (store) {
        // on unread count change, dispatch an event to the store with the new count
        (0, _intercomService.intercomOnMessage)(function (unreadCount) {
            return store.dispatch((0, _analyticsActions.intercomSetUnreadMessages)(unreadCount));
        });

        return function (next) {
            return function (action) {
                var updated = next(action);

                (0, _analyticsEventMiddleware2.default)(store)(next)(action);

                if (action.remote) return updated;

                switch (action.type) {
                    case _currentUserConstants.CURRENT_USER_SET:
                        // when we set user data, send it to intercom
                        sendUserData(action.user);
                        (0, _rollbarService.setRollbarUser)(action.user);
                        break;
                    case _currentUserConstants.CURRENT_USER_SET_GUEST:
                        // if we only have a guest user, boot interom without user
                        (0, _intercomService.intercomBoot)({
                            app_id: config.analytics.appId
                        });
                        break;
                    case _authConstants.LOGOUT:
                        // shut down intercom when user logs out
                        shutdownIntercom();
                        break;
                    case _analyticsConstants.INTERCOM_SHOW_MESSAGES:
                        (0, _intercomService.intercomShowMessenger)();
                        break;
                    default:
                        break;
                }

                return updated;
            };
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/analyticsMiddleware.js
// module id = 1662
// module chunks = 0